// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"3e4f0a7c","433":"ea6a583e"}[chunkId] + ".chunk.js";
};